import React, { useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ConfirmationDialog } from 'components/base/ConfirmationDialog/ConfirmationDialog'
import { TranslationContext } from 'contexts/TranslationContext'
import { selectShowInstallComponentMessage, selectInstallError } from 'selectors/mainView'
import { restartApplication } from 'actions/app'
import { showInstallComponentMessage } from 'actions/mainView'
import * as ActionTypes from 'actions/ActionTypes'

const clearInstallError = () => ({ type: ActionTypes.SET_INSTALL_COMPONENT_ERROR, payload: null })

export const InstallComponentMessageContainer = () => {
  const visible = useSelector(selectShowInstallComponentMessage)
  const installError = useSelector(selectInstallError)
  const dispatch = useDispatch()
  const { t } = useContext(TranslationContext)

  return (
    <>
      {visible && !installError && (
        <ConfirmationDialog
          title={t('MODAL_WINDOW_INSTALL_COMPONENT_TITLE')}
          confirmBtnText={t('MODAL_WINDOW_BUTTON_RESTART')}
          closeBtnText={t('EDITOR_MAIN_SETTINGS_BTN_CANCEL')}
          onCancel={() => dispatch(showInstallComponentMessage(false))}
          onConfirm={() => {
            dispatch(restartApplication())
            dispatch(showInstallComponentMessage(false))
          }}
        />
      )}
      {!!installError && (
        <ConfirmationDialog
          description={t(installError)}
          confirmBtnText={t('MEDIA_CONFIRM_BTN_OK')}
          closeBtnText=""
          onCancel={() => dispatch(clearInstallError())}
          onConfirm={() => dispatch(clearInstallError())}
        />
      )}
    </>
  )
}
